import React, { useState, useEffect } from 'react';
import axios from 'axios';

const StatusUpdateModal = ({ isOpen, onClose, showPopup, fetchData, API_BASE_URL, editZone }) => {
  const [status, setStatus] = useState('active');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editZone) {
      setStatus(editZone.status || 'active');
    }
  }, [editZone]);

  if (!isOpen || !editZone) {
    return null;
  }

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};

      const response = await axios.put(
        `${API_BASE_URL}/zones/${editZone.zone_id}/status`,
        { status },
        config
      );

      if (response.data.success) {
        fetchData();
        onClose();
        showPopup('Zone status updated successfully!', 'success');
      } else {
        showPopup(response.data.message || 'Failed to update zone status', 'error');
      }
    } catch (err) {
      console.error('Failed to update zone status:', err);
      showPopup('Failed to update zone status. Please try again.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.4)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: '#fff',
          padding: 15,
          borderRadius: 12,
          maxWidth: '100%',
          maxHeight: '100%',
          overflowY: 'auto',
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          color: '#222',
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
          alignItems: 'stretch',
        }}
        onClick={e => e.stopPropagation()}
      >
        <h3 style={{ marginTop: 0, marginBottom: 12, color: '#1976d2', fontSize: 16, textAlign: 'center' }}>
          Update Zone Status
        </h3>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-start', paddingLeft: 20, paddingRight: 20 }}>
          <label style={{ fontWeight: '600', color: '#1976d2', textAlign: 'left', width: 260, fontSize: 14 }}>
            Zone Name:
          </label>
          <div style={{
            width: 260,
            padding: '8px 14px',
            borderRadius: 6,
            border: '1px solid #ccc',
            fontSize: 14,
            color: '#666',
            backgroundColor: '#f5f5f5'
          }}>
            {editZone.zone_name}
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-start', paddingLeft: 20, paddingRight: 20 }}>
          <label style={{ fontWeight: '600', color: '#1976d2', textAlign: 'left', width: 260, fontSize: 14 }}>
            Current Status:
          </label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            style={{
              width: 260,
              padding: '8px 14px',
              borderRadius: 6,
              border: '1px solid #ccc',
              fontSize: 14,
              outline: 'none',
              color: '#444',
            }}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
            <option value="pending">Pending</option>
            <option value="suspended">Suspended</option>
          </select>
        </div>

        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', paddingLeft: 20, paddingRight: 20 }}>
          <button
            onClick={onClose}
            style={{
              padding: '8px 16px',
              borderRadius: 6,
              border: '1px solid #ccc',
              backgroundColor: '#f5f5f5',
              color: '#333',
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: 14,
              outline: 'none',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#e0e0e0';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = '#f5f5f5';
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              padding: '8px 16px',
              borderRadius: 6,
              border: 'none',
              backgroundColor: loading ? '#ccc' : '#1976d2',
              color: '#fff',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontWeight: '600',
              fontSize: 14,
              transition: 'background-color 0.3s ease',
              outline: 'none',
            }}
            onMouseEnter={e => {
              if (!loading) {
                e.currentTarget.style.backgroundColor = '#1565c0';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(21, 101, 192, 0.9)';
              }
            }}
            onMouseLeave={e => {
              if (!loading) {
                e.currentTarget.style.backgroundColor = '#1976d2';
                e.currentTarget.style.boxShadow = '0 6px 16px rgba(25, 118, 210, 0.7)';
              }
            }}
          >
            {loading ? 'Updating...' : 'Update Status'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusUpdateModal;
